import DailySalesManagement from './DailySalesManagement';

export default DailySalesManagement;
